import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  password: Yup.string().required(
    'authenticationFactorPage.confirmIdentityPage.password.errors.required',
  ),
});
